import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import CargomaticCollapsibleCard from 'components/v2/CollapsibleCard';
import ReferenceNumbersList from 'components/ui/tailwind/ReferenceNumber';
import EditButton from 'components/v2/buttons/EditButton';
import { sortBy } from 'lodash';
import { titleize } from 'underscore.string';

const ReferenceNumbers = (props) => {
  const order = props.order;
  if (!order) {
    return null;
  }
  const reference_numbers = (order.reference_numbers || []).filter(
    (o) => !o.hidden,
  );
  const firstSorted = sortBy(reference_numbers, (ref) =>
    ref.name.toLowerCase().includes('master'),
  ).reverse();
  const sorted = sortBy(firstSorted, (ref) =>
    ref.name.toLowerCase().includes('order'),
  );
  const { t } = useTranslation();
  return (
    <CargomaticCollapsibleCard
      id="order-reference-numbers"
      header={() => (
        <div className="flex flex-wrap justify-between items-center w-full">
          <span>{titleize(t('REFERENCE_NUMBERS'))}</span>
          <EditButton onClick={props.onEdit} />
        </div>
      )}
    >
      <ReferenceNumbersList reference_numbers={sorted} />
    </CargomaticCollapsibleCard>
  );
};

ReferenceNumbers.propTypes = {
  order: PropTypes.shape({
    reference_numbers: PropTypes.array,
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
};

export default ReferenceNumbers;
